<template>
<div></div>
</template>

<script>
export default {
    name: "subscriber",
    props: {
        stream: {
            type: OT.Stream,
            required: true
        },
        session: {
            type: OT.Session,
            required: true
        },
        opts: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            subscription: {},
            interval: {},
        };
    },

    mounted: function () {
        this.subscription = this.session.subscribe(
            this.stream,
            this.$el,
            this.opts,
            err => {
                if (err) {
                    this.$emit("error", err);
                } else {
                    //                    this.$emit("subscriberConnected", this.subscription);
                }
            }
        );
        this.subscription.on('videoDimensionsChanged', function (event) {
            console.log("Subscriber change for " + this.subscription.id + ": " + event.newValue.width + "px," + event.newValue.width + "px");
        });
        console.log("Subscriber: " + this.subscription.id);
        this.$emit("subscriberCreated", this.subscription);
        //        this.getRate();
    },
    methods: {
        getRate() {
            var newThis = this;
            console.log("Getting rate.");
            this.interval = setInterval(function () {
                if (newThis.subscription && newThis.subscription.id) {
                    var rate = newThis.subscription.videoHeight();
                    console.error("Subscriber " + newThis.subscription.id + ": " + rate);
                } else {
                    console.log("Removing subscriber interval");
                    clearInterval(newThis.interval);
                }
            }, 5000);
        }
    },
    beforeDestroy() {
        console.log("beforeDestroy for openTok Subscriber", this.subscription)
        if (this.session) {
            this.session.unsubscribe(this.subscription);
        }
    },
};
</script>
